/**
 * Author: postcodex
 */
import React, { Component, Suspense, lazy } from 'react';
import { hot } from 'react-hot-loader';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import style from '../style.scss';
import { appPropChange, searchAddresses } from '../actions';
import { debounce, isEmpty } from 'lodash';
import md5 from 'md5';
import { _sessionStorage } from '../../../api';
import LoadingBar from '../../../components/LoadingBar';

const SuggestionResults = lazy( () => import(
	/* webpackChunkName: "apps/autosuggest-address/chunks/suggestion-results" */
	/* webpackMode: "lazy" */
	/* webpackPrefetch: true */
	'../components/SuggestionResults'
	)
);

class App extends Component {
	constructor( props ) {
		super( props );

		this.debounceSearchAddreses = debounce( this.debounceSearchAddreses, 700 );
	}

	get postCodeInput() {
		return this._postCodeInput;
	}

	set postCodeInput( el ) {
		this._postCodeInput = el;
	}

	get billingCountryInput() {
		return this._counrtyInput;
	}

	set billingCountryInput( el ) {
		this._counrtyInput = el;
	}

	componentDidUpdate( prevProps, prevState, snapshot ) {
		if ( prevProps.searchingAddresses && !this.props.searchingAddresses ) {
			if ( isEmpty( this.props.addresses ) ) {
				this.props.unmountAppEntry();
			} else {
				const postcode = this._postCodeInput.value;
				if ( postcode ) {
					const hash = md5( `${ this.props.cacheId }_${ postcode }` );
					_sessionStorage.setJSON( `postcode_${ hash }`, this.props.addresses );
				}
			}
		}
	}

	componentDidMount() {
		this._postCodeInput = this.props.form.querySelector( plAutosuggestAddrObj.postcodeSelector );
		this._counrtyInput = this.props.form.querySelector( plAutosuggestAddrObj.countrySelector );
		this._address1Input = this.props.form.querySelector( plAutosuggestAddrObj.address1Selector );
		this._address2Input = this.props.form.querySelector( plAutosuggestAddrObj.address2Selector );
		this._townInput = this.props.form.querySelector( plAutosuggestAddrObj.citySelector );
		this.postCodeInput.addEventListener( 'keyup', this.handlePostCodeInputChange );

		if ( this.postCodeInput.value ) {
			this._queryAddresses( this.postCodeInput.value );
		}
	}

	componentWillUnmount() {
		this.postCodeInput.removeEventListener( 'keyup', this.handlePostCodeInputChange );
	}

	_queryAddresses = ( postcode ) => {

		const hash = md5( `${ this.props.cacheId }_${ postcode }` );
		const addresses = _sessionStorage.getJSON( `postcode_${ hash }` );
		if ( !isEmpty( addresses ) ) {
			this.props.appPropChange( { addresses } );
			return;
		}

		let args = {
			ep     : 'search-addresses',
			method : 'GET',
			postcode
		};
		if ( !postcodexLookupObj.isLoggedIn ) {
			args.options = { headers : {} };
		}

		this.props.searchAddresses( args );
	};

	debounceSearchAddreses = ( postcode ) => {
		this._queryAddresses( postcode );
	};

	handlePostCodeInputChange = ( e ) => {
		this.debounceSearchAddreses( e.target.value );
	};

	handleClickItem = ( address, e ) => {
		const { addressLine1, addressLine2, addressLine3, postTown } = address;

		if ( this._address1Input ) {
			this._address1Input.value = [addressLine1, addressLine2].filter( Boolean ).join( ', ' );
		}
		if ( this._address2Input ) {
			this._address2Input.value = addressLine3;
		}
		if ( this._townInput ) {
			this._townInput.value = postTown;
		}

		this.props.unmountAppEntry();
	};

	render() {
		const { searchingAddresses, addresses } = this.props;

		return (
			<div className={ `postcodex-lookup-app ${ style.postcodexLookupApp }` }>
				{ ( searchingAddresses && <p className={ style.searching }>Searching...</p> ) ||
				( !isEmpty( addresses ) &&
					<Suspense fallback={ <LoadingBar /> }>
						<SuggestionResults addresses={ addresses } onClick={ this.handleClickItem } />
					</Suspense> )
				}
			</div>
		);
	}
}

App.propTypes = {
	searchingAddresses : PropTypes.bool,
	addresses          : PropTypes.array,
	unmountAppEntry    : PropTypes.func,
	cacheId            : PropTypes.string,
	form               : PropTypes.instanceOf( Element ).isRequired,
};

export default hot( module )( connect(
	state => {
		return {
			...state.app
		};
	},
	{
		appPropChange,
		searchAddresses,
	}
)( App ) );
